import React from "react";
import LocalizedLink from "../../../components/localized-link";
import {
  Box,
  Button,
  styled,
  Theme,
  Typography,
  useTheme
} from "@material-ui/core";
import Imgix from "react-imgix";
import { Helmet } from "react-helmet";
import { POD_KEYS_COUNT } from "../../activation/constants";

export const WrapperSkeleton = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.grey[100],
  borderRadius: "3px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  border: `1px solid ${theme.palette.grey[300]}`,
  paddingBottom: "189px",
  [theme.breakpoints.down("xs")]: {
    paddingBottom: "168px"
  }
}));

export const WrapperLink = styled(LocalizedLink)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.grey[100],
  borderRadius: "3px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  transition: "background 100ms",
  "&:hover": {
    backgroundColor: theme.palette.grey[50],
    textDecoration: "none"
  }
}));

export const CustomImgixImage = styled(Imgix)(({ theme }) => ({
  maxWidth: "100%",
  width: "100%",
  height: "auto",
  backgroundColor: theme.palette.grey[300],
  userSelect: "none",
  // Force 1:1 apect ratio when image is loading
  "&::before": {
    content: "",
    display: "block",
    paddingTop: "100%"
  }
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontFamily: `Reckless`,
  letterSpacing: 0,
  fontSize: "2.4rem",
  lineHeight: "2.8rem",
  [theme.breakpoints.down("xs")]: {
    fontSize: "1.6rem",
    lineHeight: "1.8rem"
  }
}));

export const InfoTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component?: any }) => ({
    fontWeight: 400,
    letterSpacing: 0,
    fontSize: "1.4rem",
    lineHeight: "2rem",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.2rem",
      lineHeight: "1.6rem"
    }
  })
);

export const SecondaryInfoTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component?: any }) => ({
    fontWeight: 400,
    letterSpacing: 0,
    fontSize: "1.4rem",
    lineHeight: "2rem",
    whiteSpace: "nowrap",
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.2rem",
      lineHeight: "1.6rem"
    }
  })
);

export const PriceTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component?: any }) => ({
    whiteSpace: "nowrap",
    fontWeight: 400,
    fontFamily: `Reckless`,
    letterSpacing: 0,
    fontSize: "2rem",
    lineHeight: "2.4rem"
  })
);

export const ActionButton = styled(LocalizedLink)(
  ({ theme }: { theme: Theme; component?: any }) => ({
    background: theme.palette.common.white,
    borderRadius: 0,
    width: "100%",
    height: "38px",
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    fontSize: "1.2rem",
    textTransform: "uppercase",
    textAlign: "center",
    fontWeight: 600,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    letterSpacing: "1px",
    "&:hover": {
      background: theme.palette.grey[100]
    },
    [theme.breakpoints.up("md")]: {
      height: "44px"
    }
  })
);

export function SmallPodKeyInfo({ podKey }: { podKey: string }) {
  const theme = useTheme();
  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center">
        {/* Pod code */}
        <Typography
          component="div"
          style={{
            width: "51px",
            height: "32px",
            borderRadius: "6px",
            paddingLeft: "3px",
            letterSpacing: "2px",
            fontSize: "12px",
            lineHeight: "12px",
            fontFamily: "'Roboto Mono', monospace",
            border: `1px solid ${theme.palette.common.black}`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            userSelect: "none"
          }}
        >
          {podKey?.substring(0, POD_KEYS_COUNT / 2)}
          <br />
          {podKey?.substring(POD_KEYS_COUNT / 2, POD_KEYS_COUNT)}
        </Typography>
      </Box>
    </>
  );
}
